module.exports = __webpack_public_path__ + "assets/img/NPC037.8d092a26.png";